/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * One server the administrator connected in the identity provider console, with the values they configured there.
 */
export type OktaResourceConnectionConfirmation = {
  /**
   * The issuer URL entered on the resource app's Cross App Access settings; the identity assertion audience. Must be an https URL without query or fragment.
   */
  audience: string;
  /**
   * Server whose upstream was connected.
   */
  mcpServerId: string;
  /**
   * The identity provider app instance picked for this upstream, from the applications snapshot.
   */
  oktaApplicationId?: string | undefined;
};

/** @internal */
export type OktaResourceConnectionConfirmation$Outbound = {
  audience: string;
  mcp_server_id: string;
  okta_application_id?: string | undefined;
};

/** @internal */
export const OktaResourceConnectionConfirmation$outboundSchema: z.ZodMiniType<
  OktaResourceConnectionConfirmation$Outbound,
  OktaResourceConnectionConfirmation
> = z.pipe(
  z.object({
    audience: z.string(),
    mcpServerId: z.string(),
    oktaApplicationId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      oktaApplicationId: "okta_application_id",
    });
  }),
);

export function oktaResourceConnectionConfirmationToJSON(
  oktaResourceConnectionConfirmation: OktaResourceConnectionConfirmation,
): string {
  return JSON.stringify(
    OktaResourceConnectionConfirmation$outboundSchema.parse(
      oktaResourceConnectionConfirmation,
    ),
  );
}
